import { UI_Container } from '../Container/Container';
import styles from './Main.module.scss';

export interface MainProps {
	header?: React.ReactNode;
	breadcrumb?: React.ReactNode;
	children: React.ReactNode;
	useHeaderContainer?: boolean;
}

export const UI_Main = ({ header, breadcrumb, children, useHeaderContainer = false }: MainProps) => (
	<main id="main" className={styles.Main}>
		<header className={useHeaderContainer ? styles.Main_header : styles.Main_header___noPadding}>
			<UI_Container width="Standard">{breadcrumb}</UI_Container>
			{useHeaderContainer && <UI_Container width="Standard">{header}</UI_Container>}
			{!useHeaderContainer && <>{header}</>}
		</header>
		<article className={styles.Main_article}>{children}</article>
	</main>
);
